/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedActionPreviewPatientSchema } from '../models/PagedActionPreviewPatientSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ActionPreviewApi {
    /**
     * Get Action Preview List
     * Get action preview list. <br>Required permission: list_action_preview
     * @returns PagedActionPreviewPatientSchema OK
     * @throws ApiError
     */
    public static insuranceGetActionPreviewListGet({
        dateFrom,
        dateTo,
        patientId,
        insuranceCompanyCode,
        companyInsuranceWorkspaceId,
        limit = 100,
        offset,
    }: {
        dateFrom?: (string | null),
        dateTo?: (string | null),
        patientId?: (string | null),
        insuranceCompanyCode?: (string | null),
        companyInsuranceWorkspaceId?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedActionPreviewPatientSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/action-preview/',
            query: {
                'date_from': dateFrom,
                'date_to': dateTo,
                'patient_id': patientId,
                'insurance_company_code': insuranceCompanyCode,
                'company_insurance_workspace_id': companyInsuranceWorkspaceId,
                'limit': limit,
                'offset': offset,
            },
        });
    }
}
